import React, {Component} from 'react';
import '../css/TotalMembers.css';
import {Link} from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import localStorage from 'local-storage';
import Dropdown from 'react-dropdown';
import * as CurrencyFormat from 'react-currency-format';
import _adviserPortalHome from './_adviserPortalHome';
import { sort } from '@amcharts/amcharts4/.internal/core/utils/Iterator';

class TotalMembersComponent extends Component{
    constructor(props){
        super(props);
        this.state={
            loading: true,
            id: null,
            searchResult: [],
            totalMembers: [],
            contributorsFiltered: [],
            memberList: [],
            contributing: "all",
            sortColumn: "name",
            sortOrder: "asc",
            getProductSpecificMembers: this.getProductSpecificMembers.bind(this)
        }
    }

    static getDerivedStateFromProps(props, state){
        let id = null;
        // id = !props.id.length <= 1 ? props.id.map(id => id) : props.id
        id = props.id
        if(state.memberList !== props.memberList){
            if(!props.match.params.product){
                return {
                    memberList: props.memberList,
                    id: id
                }
            }
            else {
                return {
                    memberList: state.totalMembers,
                    id: id
                }
            }
        }
        
        if(state.searchResult && state.searchResult.length === 0){
            if(!document.getElementById("searchMember").value){
                if(state.contributorsFiltered && state.contributorsFiltered.length !== 0)
                    return {
                        searchResult: state.contributorsFiltered
                    }                    
                else 
                    return {
                        searchResult: state.memberList,
                    }
                    
                }
            else 
                return {
                    searchResult: state.searchResult
                }
        }
        else{
            if(state.memberList !== props.memberList){
                if(state.contributorsFiltered && state.contributorsFiltered.length !== 0)
                    return {
                        searchResult: state.contributorsFiltered
                    }
                else
                    return {
                        searchResult: state.memberList,
                    }
                }
            else
                return{
                    searchResult: state.searchResult
            }
              
        } 
    }
    
    componentDidMount(){
        localStorage.clear();
        // this.props.startLoadingMembers(this.props.selectedAdviserId ? this.props.selectedAdviserId : this.state.id)
        this.props.startLoadingMembers(this.state.id);
        this.state.product && this.getProductSpecificMembers(this.state.product)
        // this.setState({loading: false})
    }

    componentDidUpdate(prevProps, prevState){
        if (prevProps.match.params.product !== this.props.match.params.product){
            this.getProductSpecificMembers(this.props.match.params.product);
        }
          
        if(prevProps.memberList !== this.props.memberList){
            if(!this.state.totalMembers){
                this.setState({searchResult: this.props.memberList})
            }
            else{
                this.setState({searchResult: this.state.totalMembers})
                this.getProductSpecificMembers(this.props.match.params.product);
            }
        }
    }

    getProductSpecificMembers(product){
        this.setState({
            totalMembers: this.props.memberList && this.props.memberList.filter(member => 
                member.scheme === product).map(member => member)
        })
    }

    handleSearch(e){
        this.setState({
            searchResult: _adviserPortalHome._searchMember(e.target.value, this.props, this.state)
        })
        // const memberList = this.props.match.params.product ? this.state.totalMembers : this.props.memberList
        // let totalMembers = []
        
        // if(this.props.memberList && e.target.value){
        //     if(this.state.contributing !== "all")
        //         totalMembers = this.state.memberList.filter(member => member.hasContributions === this.state.contributing).map(member => member)
        //     else
        //         totalMembers = this.state.memberList
        //     this.searchResult =  totalMembers.filter(member => 
        //         member.firstName.toLowerCase().includes(e.target.value.toLowerCase()) ||
        //         member.lastName.toLowerCase().includes(e.target.value.toLowerCase()) ||
        //         (member.firstName.toLowerCase()+" "+member.lastName.toLowerCase()).includes(e.target.value.toLowerCase()))
        //         .map(member => member)
        //     this.setState({searchResult: this.searchResult})
        // }
        // if(!e.target.value){
        //     this.setState({
        //         searchResult: 
        //         (this.state.contributorsFiltered && this.state.contributorsFiltered.length !== 0) ? 
        //             this.state.contributorsFiltered : this.state.totalMembers})
        // }
           
    }

    _onSelect(e){
        if(!e)
            e = {
                label: "All",
                value: "all"
            }
        this.setState({contributing: e.value})
        this.filterContributors(e)
    }

    filterContributors(e){
        let totalMembers = [];
        this.state.memberList.map(member => totalMembers.push(member))
        if(e.value !== "all"){
            totalMembers = this.state.memberList.filter(member => 
                member.hasContributions === e.value).map(member => member)
        }
        this.setState({contributorsFiltered: totalMembers, searchResult: totalMembers})
    }

    _loadMember(usrMemberSetId) {
        this.props.startLoadingMemberDetails(usrMemberSetId);
        this.props.startLoadingAccountBalances(usrMemberSetId);
        this.props.startLoadingFundBalances(usrMemberSetId);
        this.props.startLoadingAccountReturns(usrMemberSetId);
        this.props.startLoadingFundReturns(usrMemberSetId);
        this.props.startLoadingMemberContribution(this.state.usrMemberSetId);
    }

    _sortBy(e, button){
        if (e.target.id==="sortName"){
            if (this.totalMembers && this.totalMembers.length!==0){
                const sorted = [...this.totalMembers].sort((a,b) => a.firstName.localeCompare(b.firstName))
                this.setState({totalMembers: sorted})
            }
        }else if(e.target.id === "sortBalance"){
            if (this.totalMembers && this.totalMembers.length!==0){
                const sorted = [...this.totalMembers].sort((a,b) => a.fum - b.fum)
                this.setState({ totalMembers: sorted })
            }
        }
    }

    render(){
        const {t} = this.props;
        const options = [
           {
               label: "All",
               value: "all"
           },
           {
               label: "Yes",
               value: "Y"
           },
           {
               label: "No",
               value: "N"
           }
          ];
        //const defaultOption = options[0];
        
        if(this.props.memberList && this.props.memberList.length !== 0){
            if(this.props.match.params.product){
                this.totalMembers = this.props.memberList.filter(member => 
                    member.scheme === this.props.match.params.product).map(member => member)
            }
            if(this.state.searchResult && this.state.searchResult.length !== 0){
                this.totalMembers = this.state.searchResult;
            }
            // else {
            //     if(!document.getElementById("searchMember"))
            //         this.totalMembers = this.state.memberList
            //     else
            //         this.totalMembers = this.state.searchResult
            // }
            
            else{
                if(document.getElementById("searchMember") && !document.getElementById("searchMember").value){
                    this.totalMembers = this.state.memberList
                }
                else if(document.getElementById("searchMember") && document.getElementById("searchMember").value){

                }
                else if(this.state.totalMembers.length!==0){
                    this.totalMembers = this.state.totalMembers
                }
                else{
                    this.totalMember = []
                }
            }
        
        }
        // if (this.totalMembers && this.totalMembers.length!==0){
        //     const sorted = [...this.totalMembers].sort((a,b) => a.firstName.localeCompare(b.firstName))
        //     this.totalMembers= sorted
        // }
        return(
            //style={{margin: "20px", paddingLeft: "100px"}}
            <div className="totalMembers">
                <header className="adviserMenu">
                    <table className="totalMembersHeader">
                        <thead>
                            <tr>
                            <th>{t('Members:header')}</th>
                            <th>
                                <input className="totalMembersHeader" id="searchMember" type="text" placeholder="Search Member" onChange={e => this.handleSearch(e)}></input>
                            </th>
                            </tr>
                        </thead>
                    </table>
                    {/* </div> */}
                </header>
                {/* <header className="adviserMenu" style={{textAlign: "left"}}>{t('total')+" "+t('member')+'s'}
                    <div style={{paddingLeft: "12px", display: "inline", float:"right"}}>
                        <input type="text" placeholder="Search Member" onChange={e => this.handleSearch(e)}></input>
                    </div>
                </header> */}
                
                <table id="totalMembers" className="totalMembers superlifeLegacyPlan">
                    <thead>
                        <tr>
                            <th style={{verticalAlign: "top"}}>{t('membersTable:name')}<button id="sortName" onClick={e => this._sortBy(e)}>V</button></th>
                            <th style={{textAlign: "center", verticalAlign: "top"}}>{t('membersTable:product')}</th>
                            <th style={{textAlign: "center", verticalAlign: "top"}}>{t('membersTable:balance')}<button id="sortBalance" onClick={e => this._sortBy(e)}>V</button></th>
                            <th style={{textAlign: "center", verticalAlign: "top"}}>{t('membersTable:contributing')}
                            {/* <Dropdown controlClassName="dropdown-box" options={options} placeholder="" value={this.state.contributing} arrowOpen={true}></Dropdown> */}
                            {/* <div> */}
                                <Dropdown controlClassName="dropdown-box-totalMembers" 
                                menuClassName="dropdown-contents-totalMembers" 
                                arrowClassName="dropdown-arrow-totalMembers"
                                options={options} 
                                onChange={ e => this._onSelect(e)}
                                value={this.state.contributing} placeholder="Select an option" arrowOpen={true}/>
                            {/* </div> */}
                            </th>
                            <th style={{textAlign: "center", verticalAlign: "top"}}>{t('membersTable:adviser')}</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        this.totalMembers && this.totalMembers.length!==0 ? this.totalMembers.map((member, index) => 
                            <tr key={index}>
                                <td style={{textAlign: "left"}}>
                                    <Link className="link" style={{color: "#51820F",fontWeight: "500"}}
                                    to={`/adv/memberSite/${member.usrMemberSetId}/personalDetails/summary`} 
                                    onClick={() => this._loadMember(member.usrMemberSetId)}>
                                            {member.firstName}{' '}{member.lastName}</Link></td>
                                <td style={{textAlign: "center"}}>{member.schemeName}</td>
                                <td style={{textAlign: "right"}}>
                                    <CurrencyFormat  value={Number(member.fum).toFixed(2)}
                                        displayType={'text'} 
                                        thousandSeparator={true} 
                                        prefix={'$'}/>
                                </td>
                                <td style={{textAlign: "center"}}>{member.hasContributions === "Y" ? "Yes" : "No"}</td>
                                <td style={{textAlign: "center"}}>{member.adviserFirstName}{' '}{member.adviserLastName}</td>
                            </tr>) : <tr><td>{t('fetching')+" "+t('member')}s....</td></tr>
                    }
                    </tbody>
                </table>

            </div>
        )
    }
}

export default withTranslation()(TotalMembersComponent);